<div style="margin: auto; max-width: 75em">
	<lb-paneled-viewer [selected]="selectedNotification">
		<ng-template pTemplate="selector">
			<dual-notification-container [(tab)]="tab"
					(onNotificationSelected)="selectedNotification = $event"
					(onSystemNotificationSelected)="selectedNotification = $event">
			</dual-notification-container>
		</ng-template>
		<ng-template pTemplate="content" let-selected>
			<ng-container *ngIf="isUserNotification(selected) as userNotification">
				<notification-entry [showShowAllButton]="false" [showNavigation]="$any(mobileMediaQuery | async)" [notification]="userNotification"></notification-entry>
			</ng-container>
			<ng-container *ngIf="isSystemNotification(selected) as systemNotification">
				<system-notification-entry [showNavigation]="$any(mobileMediaQuery | async)" [notification]="systemNotification"></system-notification-entry>
			</ng-container>
		</ng-template>
		<ng-template pTemplate="empty">
			<div class="p-d-flex p-ai-center p-jc-center">
				<h4>Select a notification to see it here</h4>
			</div>
		</ng-template>
	</lb-paneled-viewer>
</div>
